'use client';

import { c as _c } from "react/compiler-runtime";
import { colorsTuple, createTheme, MantineProvider, virtualColor } from "@mantine/core";
import { CartProvider } from "@/contexts/cartContext";
import SideCart from "@/components/layouts/public/SideCart";
import { CustomerProvider } from "@/contexts/customerContext";
import ClientNotifications from "@/components/common/ClientNotifications";
import { usePageTracking } from "@/hooks/usePageTracking";
import { getFontConfig, getShopConfig } from "@/server/shop/get-shop-config";
export default function Providers(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  usePageTracking();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const {
      headingWeight
    } = getFontConfig();
    const nshop = getShopConfig();
    t1 = createTheme({
      fontFamily: "var(--font-body)",
      autoContrast: true,
      luminanceThreshold: 0.3,
      primaryColor: "primary",
      secondaryColor: "secondary",
      colors: {
        primary: colorsTuple(nshop.theme.colors.primary),
        secondary: colorsTuple(nshop.theme.colors.secondary)
      },
      defaultRadius: "var(--radius-default)",
      headings: {
        fontFamily: "var(--font-heading)",
        fontWeight: headingWeight
      },
      fontSizes: {
        body: "0.875rem",
        xs: "0.875rem",
        sm: "1rem",
        md: "1rem"
      },
      components: {
        Button: {
          defaultProps: {
            variant: "filled",
            size: "sm",
            autoContrast: true,
            fontWeight: headingWeight
          }
        },
        TextInput: {
          defaultProps: {
            size: "md",
            radius: "md"
          }
        },
        PasswordInput: {
          defaultProps: {
            size: "md",
            radius: "md"
          }
        },
        Select: {
          defaultProps: {
            size: "md",
            radius: "md"
          }
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const theme = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SideCart />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <CustomerProvider><CartProvider>{children}{t2}</CartProvider></CustomerProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ClientNotifications />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <MantineProvider theme={theme}>{t3}{t4}</MantineProvider>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}